module.exports = __webpack_public_path__ + "img/logo-loto-vert-hotpicks-2x.01925a6b.jpg";